import { AuthenticationResponsesValidateTfaToken } from '@genial/services/dist/models';
import { atom } from 'recoil';

export const fixedFeePublicTermIdState = atom<string>({
  key: 'fixedFeePublicTermIdState',
  default: '',
});

export const fixedFeePublicAuthorizationTokenState = atom<AuthenticationResponsesValidateTfaToken>({
  key: 'fixedFeePublicAuthorizationTokenState',
  default: {
    tfaCode: '',
    jwtToken: '',
    expiration: new Date(),
  },
});
